import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICouponDayByDayDetails } from 'src/app/_interfaces/coupons/i-coupon-day-by-day-details';
import { ICouponTotalDetails } from 'src/app/_interfaces/coupons/i-coupon-total-details';
import { CouponsService } from 'src/app/_services/coupons.service';

@Component({
  selector: 'app-coupon-details',
  templateUrl: './coupon-details.component.html',
  styleUrls: ['./coupon-details.component.scss'],
})
export class CouponDetailsComponent implements OnInit {
  pageTitle: string = 'Coupons';
  couponId: number;

  basicDetailsTheadArray = [
    'Coutpon Domain',
    'Coupon EN Name',
    'Coupon AR Name',
    'Coutpon Code',
    'Coutpon Start Time',
    'Coutpon End Time',
    'Coutpon Discount Percentage',
    'Coutpon Ceiling',
    'Coutpon Use',
  ];

  testEligibilityCriteria = [
    'Test Type',
    'Tests',
    'AppliesOn',
    'VisitType',
    'Areas',
    'Labs',
    'Branch',
  ];

  appointmentEligibilityCriteria = ['Doctor Type', 'Specialities', 'Doctors'];

  testUsageSummary = {
    Patients: ['Total Number of Patients', 'Number of Unique Patients'],
    Transactions: [
      'Total Number of Transactions',
      'Paid Transactions',
      'Unpaid Transactions',
    ],
    LabsTests: ['Total Number of Unique Labs', 'Number of Unique Tests'],
  };

  appointmentUsageSummary = {
    Patients: ['Total Number of Patients', 'Number of Unique Patients'],
    Transactions: [
      'Total Number of Transactions',
      'Paid Transactions',
      'Unpaid Transactions',
    ],
    Calls: [
      'Total Number of Calls',
      'Finished Calls',
      'Cancelled Calls',
      'Not Completed Calls',
    ],
    Doctors: ['Total Number of Doctors', 'Number of Unique Doctors'],
  };

  testDBDDTheadArray = [
    'Date',
    'Number of Coupons Used',
    'Number of Unique Patients',
    'Number of Paid Transactions',
    'Number of Unpaid Transactions',
  ];

  appointmentDBDDTheadArray = [
    'Date',
    'Number of Coupons Used',
    'Number of Unique Patients',
    'Number of Paid Transactions',
    'Number of Unpaid Transactions',
    'Number of Finished Calls',
    'Number of Cancelled Calls',
    'Number of Not Completed Calls'
  ];

  theadArray = [
    'Coupon Name',
    'Day',
    'Finished Calls',
    'Cancelled Calls',
    'Not Completed Calls',
    'Coutpon Amount',
    'Number of Unique Patients',
    'Number of Unique Doctors',
  ];

  couponDayByDayList: ICouponDayByDayDetails[];

  couponTotalDetails: ICouponTotalDetails;

  constructor(
    private activatedRoute: ActivatedRoute,
    private adminCouponsService: CouponsService
  ) {}

  ngOnInit(): void {
    const id = this.activatedRoute.snapshot.params.couponId;

    if (id) {
      this.couponId = id;
      this.getCouponDetails(this.couponId);
    }
  }

  getCouponDetails(couponId) {
    this.adminCouponsService
      .getCouponDetails(couponId)
      .subscribe((response) => {
        this.couponTotalDetails = response['data']['totalDetails'];
        this.couponDayByDayList = response['data']['dayByDayDetails'];
      });
  }
}
